import React from 'react'
import ConstantsUtil from '../context/constantsUtil'
import SelectMenu from './selectMenu'

class TipoContaGerancialSelectMenu extends React.Component {

    render () {
        return (
            <>
                <label>{this.props.label}</label>
                <SelectMenu
                    className={"form-control " }
                    name={this.props.name}
                    list={ConstantsUtil.tipoContaGerencialSelectList}
                    value={this.props.value}
                    onChange={this.props.onChange}
                />
            </>
        )
    }
}

export default TipoContaGerancialSelectMenu